import { Fragment } from 'react';

import { useFormState } from 'react-final-form';

import { IUserContext } from '~/types/userContext';
import { arePlaceholderNames } from '~/util/userContextUtils';

import { useInquiryValues } from '../../context/InquiryContext';
import { InquiryFormValues } from '../../types';
import { NameField } from './NameField';

export const FIELD_NAMES: (keyof InquiryFormValues)[] = [
  'primaryFirstName',
  'primaryLastName',
  'partnerFirstName',
  'partnerLastName',
];

const isAnswered = ({
  initialValues,
  userContext,
}: {
  initialValues: InquiryFormValues;
  userContext: IUserContext | null;
}): boolean => {
  return (
    Boolean(initialValues && FIELD_NAMES.every((field) => Boolean(initialValues[field]))) &&
    !arePlaceholderNames(userContext, initialValues)
  );
};

/* only pre-auth users should see the name fields */
export const showNameFields = (
  initialValues: InquiryFormValues,
  userContext: IUserContext | null
) => {
  return !isAnswered({ initialValues, userContext });
};

type NameFieldsProps = {
  showFieldSpecificLabels?: boolean;
};
export const NameFields = (props: NameFieldsProps) => {
  const { showFieldSpecificLabels } = props;
  const { userContext } = useInquiryValues();

  const { initialValues } = useFormState<InquiryFormValues>();

  if (showNameFields(initialValues, userContext)) {
    return (
      <Fragment>
        <NameField
          field="primary"
          label={!showFieldSpecificLabels ? 'Your name' : ''}
          required
          firstNameFieldLabel={showFieldSpecificLabels ? 'First name' : ''}
          lastNameFieldLabel={showFieldSpecificLabels ? 'Last name' : ''}
        />
        <NameField
          field="partner"
          label={!showFieldSpecificLabels ? "Your partner's name" : ''}
          required
          firstNameFieldLabel={showFieldSpecificLabels ? "Partner's first name" : ''}
          lastNameFieldLabel={showFieldSpecificLabels ? "Partner's last name" : ''}
        />
      </Fragment>
    );
  }
  return <Fragment />;
};

const NameFieldsModule = {
  isAnswered,
  FIELD_NAMES,
};

export default NameFieldsModule;
